import { api } from "@/lib/api";

/** Return a stable client-side session id stored in localStorage. */
function getSessionId() {
  try {
    let sid = localStorage.getItem("lc_session_id");
    if (!sid) {
      sid = "sess_" + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      localStorage.setItem("lc_session_id", sid);
    }
    return sid;
  } catch { return null; }
}

/** Fire-and-forget analytics event. Never throws, never blocks. */
export function track(eventName, meta) {
  try {
    api.post("/analytics/event", {
      event_name: eventName,
      path: typeof window !== "undefined" ? window.location.pathname : null,
      session_id: getSessionId(),
      meta: meta || {},
    }).catch(() => { /* ignore */ });
  } catch { /* ignore */ }
}
